export const queryKeys = {
  USE_AVATAR: 'use-avatar',
  USER_PROFILE_INFO: 'user-profile-info',
  USER_PROFILE_RESULTS: 'user-profile-result',
  USER_PROFILE_STATS: 'user-profile-statistics',

};
